module.exports = __webpack_public_path__ + "fonts/finder-iconsa5d4.f9c61c1.woff";